import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import {
  DangerButton,
  InfoButton,
  SuccessButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import {
  Input,
  Radio,
  SearchInput,
  Textarea,
} from "../../../../ui/inputs/Input";
import { Dimmer } from "../../../spinner";
import { Mensaje, MensajeSiNo } from "../../../mensajes2";
import axios from "axios";
import { validaSoloNumero } from "../../../../util/varios";
import moment from "moment";
const op = require("../../../../modulos/datos");

export default function IncorporacionBienesInmuebles({
  show,
  setShow,
  setTabla,
}) {
  const token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnBuscaMotivo = useRef();
  const btnBuscaActivo = useRef();
  const btnBuscaOrden = useRef();
  const btnBuscaProve = useRef();
  const btnBuscaUbicacion = useRef();

  const txtCodigo = useRef();
  const txtCodActivo = useRef();
  const txtDescripcionActivo = useRef();
  const txtTipoMaterial = useRef();
  const txtFecha = useRef();
  const txtCodOrden = useRef();
  const txtNumFactura = useRef();
  const txtFechaAdquisicion = useRef();
  const txtCodProveedor = useRef();
  const txtRif = useRef();
  const txtNombre = useRef();
  //const txtIdUbicacion = useRef();
  const txtCodigoUbicacion = useRef();
  const txtDescripcionUbicacion = useRef();
  const txtDireccionUbicacion = useRef();
  const txtOriginal = useRef();
  const txtMas = useRef();
  const txtMenos = useRef();
  const txtActual = useRef();
  const txtCodigoBien = useRef();
  const txtCodigoBienNacional = useRef();
  const txtDenominacion = useRef();
  const txtNumExpediente = useRef();
  const txtDetalle = useRef();
  const txtAvaluoActual = useRef();
  const txtAvaluoComision = useRef();
  const txtClasificacion = useRef();
  const txtEdoLegal = useRef();
  const txtMarca = useRef();
  const txtModelo = useRef();
  const txtAnio = useRef();
  const txtColor = useRef();
  const txtCapacidad = useRef();
  const txtTipo = useRef();
  const txtSeriales = useRef();
  const txtNumPieza = useRef();
  const txtPlaca = useRef();
  const txtUso = useRef();
  const txtAlto = useRef();
  const txtLargo = useRef();
  const txtAncho = useRef();
  const txtObservacion = useRef();
  const txtCedula = useRef();
  const txtNombreResponsa = useRef();
  const txtCargo = useRef();
  const txtEste = useRef();
  const txtNorte = useRef();
  const txtOeste = useRef();
  const txtSur = useRef();
  const txtAreaTerreno = useRef();
  const txtAreaConstruccion = useRef();
  const txtAreaCubierta = useRef();
  const txtOtrasInsta = useRef();
  const txtCodMotivo = useRef();
  const txtDescripcionMotivo = useRef();
  const txtValorInicial = useRef();
  const txtValorRescate = useRef();
  const txtDepresiacionMensual = useRef();
  const txtDepresiacionAcumulada = useRef();
  const txtValorLibros = useRef();
  const txtValorAdicion = useRef();
  const txtValorReexpresado = useRef();
  const txtCostoReposicion = useRef();
  const radioPropio = useRef();
  const radioArrendado = useRef();
  const txtPeriodoArrendamiento = useRef();

  const [operacion, setOperacion] = useState(0);
  const [txtOperacion, setTxtOperacion] = useState("");
  const [activate, setActivate] = useState(false);
  const [visibleButton, setVisibleButton] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [mostrarCatalogoCuenta, setMostrarCatalogoCuenta] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const onChange = (e) => {
    if (e.target.value !== "") {
      e.target.value = e.target.value.toUpperCase();
    }
  };

  const onNextChange = (e) => {
    if (e.which === 13) {
      if (e.target.name === "codigoactivo") {
        txtDescripcionActivo.current.focus();
      } else if (e.target.name === "tipomaterial") {
        btnAcepta.current.focus();
      }
    }
  };

  const validarCodigo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodigo.current.blur();
        seleccionarRegistro();
      } else {
        /*         txtCodActivo.current.value = "";
        txtDescripcion.current.value = "";
        radioMueble.current.checked = true;
        radioInmueble.current.checked = true;
        txtTipoMaterial.current.value = "";
        txtCodClasificaBienes.current.value = "";
        txtGrupo.current.value = "";
        txtSubGrupo.current.value = "";
        txtSeccion.current.value = "";
        txtDescripClaseBien.current.value = ""; */
      }
    }
  };

  const validarCodigoActivo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodActivo.current.blur();
        seleccionarRegistroTipoActivo();
      } else {
        txtCodActivo.current.value = "";
        txtDescripcionActivo.current.value = "";
        txtTipoMaterial.current.value = "";
      }
    }
  };

  const validarCodigoOrdenPago = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodOrden.current.blur();
        seleccionarOrdenPago();
      } else {
        txtCodOrden.current.value = "";
        txtNumFactura.current.value = "";
      }
    }
  };

  const validarCodigoProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodProveedor.current.blur();
        seleccionarRegistroProveedor();
      } else {
        txtCodProveedor.current.value = "";
        txtRif.current.value = "";
        txtNombre.current.value = "";
      }
    }
  };

  const validarCodigoUbicacion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodigoUbicacion.current.blur();
        seleccionarRegistroUbicacion();
      } else {
        txtCodigoUbicacion.current.value = "";
        txtDescripcionUbicacion.current.value = "";
        txtDireccionUbicacion.current.value = "";
        txtCedula.current.value = "";
        txtNombreResponsa.current.value = "";
      }
    }
  };

  const validarCodigoMotivo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodMotivo.current.blur();
        seleccionarRegistroMotivo();
      } else {
        txtCodMotivo.current.value = "";
        txtDescripcionMotivo.current.value = "";
      }
    }
  };

  const habilitarCampos = () => {
    txtCodActivo.current.disabled = false;
    txtFecha.current.disabled = false;
    txtCodOrden.current.disabled = false;
    txtNumFactura.current.disabled = false;
    txtFechaAdquisicion.current.disabled = false;
    txtCodProveedor.current.disabled = false;
    //txtIdUbicacion.current.disabled = false;
    txtCodigoUbicacion.current.disabled = false;
    txtOriginal.current.disabled = false;
    txtMas.current.disabled = false;
    txtMenos.current.disabled = false;
    txtCodigoBien.current.disabled = false;
    txtCodigoBienNacional.current.disabled = false;
    txtDenominacion.current.disabled = false;
    txtNumExpediente.current.disabled = false;
    txtDetalle.current.disabled = false;
    txtAvaluoActual.current.disabled = false;
    txtAvaluoComision.current.disabled = false;
    txtClasificacion.current.disabled = false;
    txtEdoLegal.current.disabled = false;
    txtObservacion.current.disabled = false;
    //btnBuscaRespon.current.disabled = false;
    //txtCargo.current.disabled = false;
    txtEste.current.disabled = false;
    txtNorte.current.disabled = false;
    txtOeste.current.disabled = false;
    txtSur.current.disabled = false;
    txtAreaTerreno.current.disabled = false;
    txtAreaConstruccion.current.disabled = false;
    txtAreaCubierta.current.disabled = false;
    txtOtrasInsta.current.disabled = false;
    txtCodMotivo.current.disabled = false;
    //btnBuscaMotivo.current.disabled = false;
    txtValorInicial.current.disabled = false;
    txtValorRescate.current.disabled = false;
    txtDepresiacionMensual.current.disabled = false;
    txtDepresiacionAcumulada.current.disabled = false;
    txtValorLibros.current.disabled = false;
    txtValorAdicion.current.disabled = false;
    txtValorReexpresado.current.disabled = false;
    txtCostoReposicion.current.disabled = false;
    radioPropio.current.disabled = false;
    radioArrendado.current.disabled = false;

    ////cTabFolder.setSelection(0);
    //cTabFolder.current.disabled = false;
    /* 		btnBuscaActivo.current.disabled = false;
		btnBuscaOrden.current.disabled = false;
		btnBuscaProve.current.disabled = false;
		btnBuscaUbicacion.current.disabled = false;
		btnBuscaMotivo.current.disabled = false; */
  };

  const deshabilitarCampos = () => {
    txtCodigo.current.disabled = true;
    txtCodActivo.current.disabled = true;
    txtFecha.current.disabled = true;
    txtDescripcionActivo.current.disabled = true;
    txtTipoMaterial.current.disabled = true;
    txtCodOrden.current.disabled = true;
    txtNumFactura.current.disabled = true;
    txtFechaAdquisicion.current.disabled = true;
    txtCodProveedor.current.disabled = true;
    txtRif.current.disabled = true;
    txtNombre.current.disabled = true;
    txtIdUbicacion.current.disabled = true;
    txtCodigoUbicacion.current.disabled = true;
    txtDescripcionUbicacion.current.disabled = true;
    txtDireccionUbicacion.current.disabled = true;
    txtOriginal.current.disabled = true;
    txtMas.current.disabled = true;
    txtMenos.current.disabled = true;
    txtActual.current.disabled = true;
    txtCodigoBien.current.disabled = true;
    txtCodigoBienNacional.current.disabled = true;
    txtDenominación.current.disabled = true;
    txtNumExpediente.current.disabled = true;
    txtDetalle.current.disabled = true;
    txtAvaluoActual.current.disabled = true;
    txtAvaluoComision.current.disabled = true;
    txtClasificacion.current.disabled = true;
    txtEdoLegal.current.disabled = true;
    txtObservacion.current.disabled = true;
    composite1.current.disabled = true;
    txtPeriodoArrendamiento.current.disabled = true;
    txtCedula.current.disabled = true;
    //btnBuscaRespon.current.disabled = true;
    txtNombreResponsa.current.disabled = true;
    txtCargo.current.disabled = true;
    txtEste.current.disabled = true;
    txtNorte.current.disabled = true;
    txtOeste.current.disabled = true;
    txtSur.current.disabled = true;
    txtAreaTerreno.current.disabled = true;
    txtAreaConstruccion.current.disabled = true;
    txtAreaCubierta.current.disabled = true;
    txtOtrasInsta.current.disabled = true;
    txtCodMotivo.current.disabled = true;
    //btnBuscaMotivo.current.disabled = true;
    txtDescripcionMotivo.current.disabled = true;
    txtValorInicial.current.disabled = true;
    txtValorRescate.current.disabled = true;
    txtDepresiacionMensual.current.disabled = true;
    txtDepresiacionAcumulada.current.disabled = true;
    txtValorLibros.current.disabled = true;
    txtValorAdicion.current.disabled = true;
    txtValorReexpresado.current.disabled = true;
    txtCostoReposicion.current.disabled = true;
    radioPropio.current.disabled = true;
    radioArrendado.current.disabled = true;
    /* 		btnImprimir.current.disabled = true;	
		//cTabFolder.setSelection(0);
		cTabFolder.current.disabled = true;
		btnBuscaActivo.current.disabled = true;
		btnBuscaOrden.current.disabled = true;
		btnBuscaProve.current.disabled = true;
		btnBuscaUbicacion.current.disabled = true;
		btnBuscaMotivo.current.disabled = true; */
  };

  const blanquear = () => {
    txtCodigo.current.value = "";
    txtCodActivo.current.value = "";
    txtDescripcionActivo.current.value = "";
    txtTipoMaterial.current.value = "";
    txtFecha.current.value = "";
    txtCodOrden.current.value = "";
    txtNumFactura.current.value = "";
    txtFechaAdquisicion.current.value = "";
    txtCodProveedor.current.value = "";
    txtRif.current.value = "";
    txtNombre.current.value = "";
    txtCodigoUbicacion.current.value = "";
    txtDescripcionUbicacion.current.value = "";
    txtDireccionUbicacion.current.value = "";
    txtOriginal.current.value = "";
    txtMas.current.value = "";
    txtMenos.current.value = "";
    txtActual.current.value = "";
    txtCodigoBien.current.value = "";
    txtCodigoBienNacional.current.value = "";
    txtDenominacion.current.value = "";
    txtNumExpediente.current.value = "";
    txtDetalle.current.value = "";
    txtAvaluoActual.current.value = "";
    txtAvaluoComision.current.value = "";
    txtClasificacion.current.value = "";
    txtEdoLegal.current.value = "";
    txtObservacion.current.value = "";
    txtCedula.current.value = "";
    txtNombreResponsa.current.value = "";
    txtEste.current.value = "";
    txtNorte.current.value = "";
    txtOeste.current.value = "";
    txtSur.current.value = "";
    txtAreaTerreno.current.value = "";
    txtAreaConstruccion.current.value = "";
    txtAreaCubierta.current.value = "";
    txtOtrasInsta.current.value = "";
    txtCodMotivo.current.value = "";
    txtDescripcionMotivo.current.value = "";
    txtValorInicial.current.value = "";
    txtValorRescate.current.value = "";
    txtDepresiacionMensual.current.value = "";
    txtDepresiacionAcumulada.current.value = "";
    txtValorLibros.current.value = "";
    txtValorAdicion.current.value = "";
    txtValorReexpresado.current.value = "";
    txtCostoReposicion.current.value = "";
    radioPropio.current.checked = true;
    radioArrendado.current.checked = false;
    txtPeriodoArrendamiento.current.value = "";

    setOperacion(0);
    setTxtOperacion("");
    setVisibleButton(true);
    setDisabled(true);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });

    setActivate(false);
  };

  const procesarRegistro = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/incorporacioninmueble/actualizar`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto:
              "registro " +
              response.data.incorporacioninmueble_act +
              " procesado correctamente",
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        if (
          mensaje ===
          `duplicate key value violates unique constraint "incorporacioninmueble_pkey"`
        ) {
          mensaje = "Ya Existe un inmueble con ese codigo.";
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  function formato(n, f) {
    try {
      const numero = parseFloat(n);

      // Verificamos si el parseo falló (NaN)
      if (isNaN(numero)) return false;

      // En JS, el formato se define con objetos de configuración
      // Ejemplo rápido: { minimumFractionDigits: 2 }
      // Nota: El string "f" de Java no es 1:1 compatible con JS
      const formatter = new Intl.NumberFormat("es-ES");
      const valor = formatter.format(numero);

      return true;
    } catch (e) {
      return false;
    }
  }

  function esFechaValida(f) {
    try {
      // Paso 1: Extraer subcadenas
      const dStr = f.slice(0, 2);
      const mStr = f.slice(3, 5);
      const aStr = f.slice(6, 10);

      // Paso 2: Manejo de años (Lógica de caracteres 'A')
      let anio = 2000; // Valor por defecto
      if (!aStr.includes("A")) {
        anio = parseInt(aStr);
      }

      // Paso 3: Manejo de meses (Lógica de caracteres 'M')
      let mes = 0; // Enero es 0 en JS
      if (!mStr.includes("M")) {
        mes = parseInt(mStr) - 1;
        if (mes < 0 || mes > 11) return false;
      }

      // Paso 4: Manejo de días (Lógica de caracteres 'D')
      if (!dStr.includes("D")) {
        const dia = parseInt(dStr);

        // Creamos fecha para validar desbordamiento
        const fechaTest = new Date(anio, mes, dia);

        // Si el mes o el día no coinciden, la fecha es inválida (ej: 31 de abril)
        if (
          fechaTest.getFullYear() !== anio ||
          fechaTest.getMonth() !== mes ||
          fechaTest.getDate() !== dia
        ) {
          return false;
        }
      } else {
        // Lógica específica para Febrero y caracteres 'D'
        if (mes === 1) {
          // Febrero
          const primerChar = dStr.charAt(0);
          if (primerChar !== "D" && primerChar > "2") return false;
        }
      }

      return true;
    } catch (e) {
      return false;
    }
  }

  const ValidarCampos = () => {
    let vali;
    let fec;
    let valido = true;

    let val2 = "";
    let val3 = "";
    if (txtAvaluoActual.current.value.toString().length >= 3) {
      val2 = txtAvaluoActual.current.value
        .substring(
          txtAvaluoActual.current.value.toString().length - 3,
          txtAvaluoActual.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtAvaluoActual.current.value
          .substring(0, txtAvaluoActual.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtAvaluoActual.current.value.trim() === "") {
      txtAvaluoActual.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtAvaluoActual.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Avaluo Actual Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(1);
      txtAvaluoActual.current.focus();
      return false;
    }
    if (txtAvaluoComision.current.value.toString().length >= 3) {
      val2 = txtAvaluoComision.current.value
        .substring(
          txtAvaluoComision.current.value.toString().length - 3,
          txtAvaluoComision.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtAvaluoComision.current.value
          .substring(0, txtAvaluoComision.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtAvaluoComision.current.value.trim() === "") {
      txtAvaluoComision.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtAvaluoComision.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Avaluo Comisión Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(1);
      txtAvaluoComision.current.focus();
      return false;
    }

    if (txtAreaTerreno.current.value.toString().length >= 3) {
      val2 = txtAreaTerreno.current.value
        .substring(
          txtAreaTerreno.current.value.toString().length - 3,
          txtAreaTerreno.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtAreaTerreno.current.value
          .substring(0, txtAreaTerreno.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtAreaTerreno.current.value.trim() === "") {
      txtAreaTerreno.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtAreaTerreno.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Valor del Area de Terreno Inválido",
        icono: "informacion",
      });
      ////cTabFolder.setSelection(2);
      txtAreaTerreno.current.focus();
      return false;
    }
    if (txtAreaConstruccion.current.value.toString().length >= 3) {
      val2 = txtAreaConstruccion.current.value
        .substring(
          txtAreaConstruccion.current.value.toString().length - 3,
          txtAreaConstruccion.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtAreaConstruccion.current.value
          .substring(0, txtAreaConstruccion.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtAreaConstruccion.current.value.trim() === "") {
      txtAreaConstruccion.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtAreaConstruccion.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Valor del Area de Construcción Inválido",
        icono: "informacion",
      });
      ////cTabFolder.setSelection(2);
      txtAreaConstruccion.current.focus();
      return false;
    }
    if (txtAreaCubierta.current.value.toString().length >= 3) {
      val2 = txtAreaCubierta.current.value
        .substring(
          txtAreaCubierta.current.value.toString().length - 3,
          txtAreaCubierta.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtAreaCubierta.current.value
          .substring(0, txtAreaCubierta.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtAreaCubierta.current.value.trim() === "") {
      txtAreaCubierta.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtAreaCubierta.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Valor del Area de Cubierta Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(2);
      txtAreaCubierta.current.focus();
      return false;
    }
    if (txtOtrasInsta.current.value.toString().length >= 3) {
      val2 = txtOtrasInsta.current.value
        .substring(
          txtOtrasInsta.current.value.toString().length - 3,
          txtOtrasInsta.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtOtrasInsta.current.value
          .substring(0, txtOtrasInsta.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtOtrasInsta.current.value.trim() === "") {
      txtOtrasInsta.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtOtrasInsta.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Valor del Otras Instalaciones Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(2);
      txtOtrasInsta.current.focus();
      return false;
    }

    if (txtValorInicial.current.value.toString().length >= 3) {
      val2 = txtValorInicial.current.value
        .substring(
          txtValorInicial.current.value.toString().length - 3,
          txtValorInicial.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtValorInicial.current.value
          .substring(0, txtValorInicial.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtValorInicial.current.value.trim() === "") {
      txtValorInicial.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtValorInicial.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Inicial Inválido",
        icono: "informacion",
      });
      ////cTabFolder.setSelection(3);
      txtValorInicial.current.focus();
      return false;
    }
    if (txtValorRescate.current.value.toString().length >= 3) {
      val2 = txtValorRescate.current.value
        .substring(
          txtValorRescate.current.value.toString().length - 3,
          txtValorRescate.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtValorRescate.current.value
          .substring(0, txtValorRescate.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtValorRescate.current.value.trim() === "") {
      txtValorRescate.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtValorRescate.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Rescate Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(3);
      txtValorRescate.current.focus();
      return false;
    }
    if (txtDepresiacionMensual.current.value.toString().length >= 3) {
      val2 = txtDepresiacionMensual.current.value
        .substring(
          txtDepresiacionMensual.current.value.toString().length - 3,
          txtDepresiacionMensual.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtDepresiacionMensual.current.value
          .substring(0, txtDepresiacionMensual.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtDepresiacionMensual.current.value.trim() === "") {
      txtDepresiacionMensual.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtDepresiacionMensual.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Depresiación Mensual Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(3);
      txtDepresiacionMensual.current.focus();
      return false;
    }
    if (txtDepresiacionAcumulada.current.value.toString().length >= 3) {
      val2 = txtDepresiacionAcumulada.current.value
        .substring(
          txtDepresiacionAcumulada.current.value.toString().length - 3,
          txtDepresiacionAcumulada.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtDepresiacionAcumulada.current.value
          .substring(0, txtDepresiacionAcumulada.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtDepresiacionAcumulada.current.value.trim() === "") {
      txtDepresiacionAcumulada.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtDepresiacionAcumulada.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Depresiación Acumulada Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(3);
      txtDepresiacionAcumulada.current.focus();
      return false;
    }
    if (txtValorLibros.current.value.toString().length >= 3) {
      val2 = txtValorLibros.current.value
        .substring(
          txtValorLibros.current.value.toString().length - 3,
          txtValorLibros.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtValorLibros.current.value
          .substring(0, txtValorLibros.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtValorLibros.current.value.trim() === "") {
      txtValorLibros.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtValorLibros.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Libros Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(3);
      txtValorLibros.current.focus();
      return false;
    }
    if (txtValorAdicion.current.value.toString().length >= 3) {
      val2 = txtValorAdicion.current.value
        .substring(
          txtValorAdicion.current.value.toString().length - 3,
          txtValorAdicion.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtValorAdicion.current.value
          .substring(0, txtValorAdicion.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtValorAdicion.current.value.trim() === "") {
      txtValorAdicion.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtValorAdicion.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Adición Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(3);
      txtValorAdicion.current.focus();
      return false;
    }
    if (txtValorReexpresado.current.value.toString().length >= 3) {
      val2 = txtValorReexpresado.current.value
        .substring(
          txtValorReexpresado.current.value.toString().length - 3,
          txtValorReexpresado.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtValorReexpresado.current.value
          .substring(0, txtValorReexpresado.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtValorReexpresado.current.value.trim() === "") {
      txtValorReexpresado.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtValorReexpresado.current.value;

    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Reexpresado Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(3);
      txtValorReexpresado.current.focus();
      return false;
    }
    if (txtCostoReposicion.current.value.toString().length >= 3) {
      val2 = txtCostoReposicion.current.value
        .substring(
          txtCostoReposicion.current.value.toString().length - 3,
          txtCostoReposicion.current.value.toString().length,
        )
        .replace(".", ",");
      val3 =
        txtCostoReposicion.current.value
          .substring(0, txtCostoReposicion.current.value.toString().length - 3)
          .replace(".", "") + val2.replace(",", ".");
    } else if (txtCostoReposicion.current.value.trim() === "") {
      txtCostoReposicion.current.value = "0,00";
      val3 = "0.00";
    } else val3 = txtCostoReposicion.current.value;
    if (!formato(val3, "##,###,###,##0.00")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Costo Reposición Inválido",
        icono: "informacion",
      });
      //cTabFolder.setSelection(3);
      txtCostoReposicion.current.focus();
      return false;
    }

    if (operacion !== 1 && txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(0);
      txtCodigo.current.focus();
    } else if (txtCodActivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código del Activo no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(0);
      txtCodActivo.current.focus();
    } else if (txtDescripcionActivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Descripción del Activo no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(0);
      txtCodActivo.current.focus();
    } else if (txtFecha.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Favor Ingrese la Fecha de Incorporación",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(0);
      txtFecha.current.focus();
    } else if (txtFechaAdquisicion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Favor Ingrese la Fecha de Adquisición",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(0);
      txtFechaAdquisicion.current.focus();
    } else if (txtCodigoUbicacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código de la Ubicación no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(0);
      txtCodigoUbicacion.current.focus();
    } else if (txtCodigoUbicacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Descripción de la Ubicación no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(0);
      txtIdUbicacion.current.focus();
    } else if (txtCodigoBien.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código del Bien no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(1);
      txtCodigoBien.current.focus();
    } else if (txtDenominacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Denominación del Inmueble no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(1);
      txtDenominacion.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Cédula del Responsable Patrimonial no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(1);
      txtCedula.current.focus();
    } else if (txtNombreResponsa.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Nombre del Responsable Patrimonial no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(1);
      txtNombreResponsa.current.focus();
    } else if (txtCodMotivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código del Motivo de Incorporación no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(2);
      txtCodMotivo.current.focus();
    } else if (txtDescripcionMotivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Descripción del Motivo de Incorporación no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      //cTabFolder.setSelection(2);
      txtDescripcionMotivo.current.focus();
    } 

    /* 		if (!valido) {
			mensaje.setText("Informacion");
			mensaje.open();
		} */

    return valido;
  };

  const onChangeValidar = async () => {
    let sigue = ValidarCampos();
    if (sigue) {
      let valId = [];

      valId.push(txtCodActivo.current.value);
      valId.push(
        txtCodOrden.current.value === "" ? "0" : txtCodOrden.current.value,
      );
      valId.push(txtCodigoUbicacion.current.value);
      valId.push(txtCodMotivo.current.value);
      valId.push(
        txtCodProveedor.current.value === ""
          ? "0"
          : txtCodProveedor.current.value,
      );
      valId.push(
        txtNumFactura.current.value === ""
          ? "null"
          : txtNumFactura.current.value,
      );

      let datres = [];

      datres.push(
        txtCodigoBien.current.value === ""
          ? "null"
          : txtCodigoBien.current.value.trim().toUpperCase(),
      );
      datres.push(moment(txtFechaAdquisicion.current.value).format('YYYY-MM-DD'));
      datres.push(radioPropio.current.checked ? 0 : 1);
      datres.push(
        txtPeriodoArrendamiento.current.value === ""
          ? "null"
          : txtPeriodoArrendamiento.current.value.trim().toUpperCase(),
      );
      datres.push(
        txtCodigoBienNacional.current.value === ""
          ? "null"
          : txtCodigoBienNacional.current.value.trim().toUpperCase(),
      );

      const datos = {
        operacion: operacion,
        nid: txtCodigo.current.value === "" ? 0 : txtCodigo.current.value,
        valorid: JSON.stringify(valId),
        vidautiliori:
          txtOriginal.current.value === ""
            ? 0
            : parseInt(txtOriginal.current.value),
        nvidautilmas:
          txtMas.current.value === "" ? 0 : parseInt(txtMas.current.value),
        nvidautilmenos:
          txtMenos.current.value === "" ? 0 : parseInt(txtMenos.current.value),
        denomina: txtDenominacion.current.value.toUpperCase(),
        numexp:
          txtNumExpediente.current.value === ""
            ? 0
            : parseInt(txtNumExpediente.current.value),
        cdetalle: txtDetalle.current.value.toUpperCase(),
        navaluoactual: parseFloat(
          txtAvaluoActual.current.value.replace(/\./g, "").replace(",", "."),
        ),
        navaluocomision: parseFloat(
          txtAvaluoComision.current.value.replace(/\./g, "").replace(",", "."),
        ),
        clasificacion: txtClasificacion.current.value.toUpperCase(),
        estadolegal: txtEdoLegal.current.value.toUpperCase(),
        observacion:
          txtObservacion.current.value.trim().toString().length > 700
            ? txtObservacion.current.value
                .trim()
                .substring(0, 699)
                .toUpperCase()
            : txtObservacion.current.value.trim().toUpperCase(),
        norte: txtNorte.current.value.toUpperCase(),
        sur: txtSur.current.value.toUpperCase(),
        este: txtEste.current.value.toUpperCase(),
        oeste: txtOeste.current.value.toUpperCase(),
        aterreno: parseFloat(
          txtAreaTerreno.current.value.replace(/\./g, "").replace(",", "."),
        ),
        acubierta: parseFloat(
          txtAreaCubierta.current.value.replace(/\./g, "").replace(",", "."),
        ),
        aconstruccion: parseFloat(
          txtAreaConstruccion.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        ),
        otrasinsta: parseFloat(
          txtOtrasInsta.current.value.replace(/\./g, "").replace(",", "."),
        ),
        nvalorinicial: parseFloat(
          txtValorInicial.current.value.replace(/\./g, "").replace(",", "."),
        ),
        nvalorrescate: parseFloat(
          txtValorRescate.current.value.replace(/\./g, "").replace(",", "."),
        ),
        depremensual: parseFloat(
          txtDepresiacionMensual.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        ),
        depreacumulada: parseFloat(
          txtDepresiacionAcumulada.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        ),
        nvalorlibros: parseFloat(
          txtValorLibros.current.value.replace(/\./g, "").replace(",", "."),
        ),
        nvaloradicion: parseFloat(
          txtValorAdicion.current.value.replace(/\./g, "").replace(",", "."),
        ),
        valorreexpre: parseFloat(
          txtValorReexpresado.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        ),
        costorepo: parseFloat(
          txtCostoReposicion.current.value.replace(/\./g, "").replace(",", "."),
        ),
        fecincor: moment(txtFecha.current.value).format('YYYY-MM-DD'),
        cdatres: JSON.stringify(datres),
      };

      await procesarRegistro({
        datos: datos,
      });
    }
  };

  const seleccionarRegistro = async () => {
    const campos = "*";
    const id = txtCodigo.current.value;
    const nomtab = "incorporacioninmueble";
    const nomid = "idincorporacioninmueble";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            if (data.status === 1) {
              txtCodigo.current.value = "";
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Bien Inmueble fue Desincorporado",
                icono: "informacion",
              });
            } else {
              setDisabled(operacion !== 2);

              /*       if (operacion == 4) {
						btnImprimir.setEnabled(true);
					}else {
						btnImprimir.setEnabled(false);
					} */

              txtCodActivo.current.value = data.idtipoactivo;
              txtCodOrden.current.value =
                data.idordenpago == 0 ? "" : data.idordenpago;
              txtNumFactura.current.value =
                data.numfactura == null ? "" : data.numfactura.trim();
              txtCodProveedor.current.value =
                data.idproveedor == 0 ? "" : data.idproveedor;
              txtIdUbicacion.current.value = data.idubicacionbien;
              txtOriginal.current.value = data.vidautiloriginal;
              txtMas.current.value = data.vidautilmas;
              txtMenos.current.value = data.vidautilmenos;
              txtCodigoBien.current.value =
                data.codigobien == null ? "" : data.codigobien.trim();
              txtCodigoBienNacional.current.value =
                data.codigobiennacional == null
                  ? ""
                  : data.codigobiennacional.trim();
              txtDenominacion.current.value =
                data.denominacion == null ? "" : data.denominacion.trim();
              txtNumExpediente.current.value = data.numeroexpediente;
              txtDetalle.current.value =
                data.detalle == null ? "" : data.detalle.trim();
              txtAvaluoActual.current.value = data.avaluoactual;
              txtAvaluoComision.current.value = data.avaluocomision;
              txtClasificacion.current.value =
                data.clasificacionfuncional == null
                  ? ""
                  : data.clasificacionfuncional.trim();
              txtEdoLegal.current.value =
                data.estadolegalcontruccion == null
                  ? ""
                  : data.estadolegalcontruccion.trim();
              txtObservacion.current.value =
                data.observacionincorporacion == null
                  ? ""
                  : data.observacionincorporacion.trim();

              if (data.propio == 0) {
                radioPropio.current.checked = true;
                radioArrendado.current.checked = false;
                txtPeriodoArrendamiento.current.disabled = true;
              } else {
                radioPropio.current.checked = false;
                radioArrendado.current.checked = true;
                txtPeriodoArrendamiento.current.disabled = false;
              }

              txtPeriodoArrendamiento.current.value =
                data.periodoarrend == null ? "" : data.periodoarrend.trim();
              /*txtCedula.current.value = data.cedularesponsable;
					txtNombreResponsa.current.value = data.nombreresponsable == null ? "" : data.nombreresponsable.trim());
					txtCargo.current.value = data.cargoresponsable == null ? "" : data.cargoresponsable.trim());*/
              txtNorte.current.value =
                data.linderonorte == null ? "" : data.linderonorte.trim();
              txtSur.current.value =
                data.linderosur == null ? "" : data.linderosur.trim();
              txtEste.current.value =
                data.linderoeste == null ? "" : data.linderoeste.trim();
              txtOeste.current.value =
                data.linderooeste == null ? "" : data.linderooeste.trim();
              txtAreaTerreno.current.value = data.areaterreno;
              txtAreaConstruccion.current.value = data.areaconstruccion;
              txtAreaCubierta.current.value = data.areacubierta;
              txtOtrasInsta.current.value = data.otrasinstalaciones;
              txtCodMotivo.current.value = data.idmotivoincorporacion;
              txtValorInicial.current.value = data.valorinicial;
              txtValorRescate.current.value = data.valorrescate;
              txtDepresiacionMensual.current.value = data.depresiacionmensual;
              txtDepresiacionAcumulada.current.value =
                data.depresiacionacumulada;
              txtValorLibros.current.value = data.valorlibros;
              txtValorAdicion.current.value = data.valoradicion;
              txtValorReexpresado.current.value = data.valorreexpresado;
              txtCostoReposicion.current.value = data.costoreposicion;
              txtFecha.current.value =
                data.fechaincorporacion.toString().substring(8, 10) +
                "/" +
                data.fechaincorporacion.toString().substring(5, 7) +
                "/" +
                data.fechaincorporacion.toString().substring(0, 4);
              //valida = false;
              txtFechaAdquisicion.current.value =
                data.fechaadquisicion == null
                  ? "DD/MM/AAAA"
                  : data.fechaadquisicion.toString().substring(8, 10) +
                    "/" +
                    data.fechaadquisicion.toString().substring(5, 7) +
                    "/" +
                    data.fechaadquisicion.toString().substring(0, 4);
              //valida = true;
              //idAsiAnt = data.idasiento;
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Bien Inmueble no existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroProveedor = async () => {
    const campos = "*";
    const id = txtCodProveedor.current.value;
    const nomtab = "proveedor";
    const nomid = "idproveedor";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;

            txtRif.current.value = data.rif;
            txtNombre.current.value = data.razonsocial;
          } else {
            txtCodProveedor.current.value = "";
            txtRif.current.value = "";
            txtNombre.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Proveedor no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroTipoActivo = async () => {
    const campos = "*";
    const id = txtCodActivo.current.value;
    const nomtab = "tipoactivo";
    const nomid = "idtipoactivo";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            console.log(data);

            if (data.tipobien === 0) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El el tipo de activo no es inmueble",
                icono: "informacion",
              });
              txtCodActivo.current.value = "";
              txtCodActivo.current.focus();
            } else {
              txtDescripcionActivo.current.value = data.descripcion;
              txtTipoMaterial.current.value =
                data.tipomaterial === null ? "" : data.tipomaterial;
              // idClaseBien = rs.getLong("idclasificabienes");
            }
          } else {
            txtCodActivo.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Tipo Activo no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroUbicacion = async () => {
    const campos = "u.*, (p.apellidos || ' ' || p.nombres) As nombre ";
    const id = txtCodigoUbicacion.current.value;
    const nomtab = "ubicacionbien u, persona p";
    const nomid = "idubicacionbien";
    const condic =
      " u.cedularesponsable = p.cedula AND ubicacionfisica = true ";

    const endpoint = `${op.conexion}/api/consulta/modelicondi?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&condic=${condic}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const data = response.data[0];

            console.log(data);

            let cod =
              data.codigoubicacion.substring(0, 2) +
              "-" +
              data.codigoubicacion.substring(2, 4) +
              "-" +
              data.codigoubicacion.substring(4, 6) +
              "-" +
              data.codigoubicacion.substring(6, 8);

            txtDescripcionUbicacion.current.value = cod;
            txtDireccionUbicacion.current.value = data.descripcionubicacionbien;
            txtCedula.current.value = data.cedularesponsable;
            txtNombreResponsa.current.value = data.nombre;
          } else {
            txtCodigoUbicacion.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La ubicacion no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroMotivo = async () => {
    const campos = "*";
    const id = txtCodMotivo.current.value;
    const nomtab = "motivoincorporacion";
    const nomid = "idmotivoincorporacion";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtDescripcionMotivo.current.value =
              data.descripcionincorporacion.trim();
            //generaAsiento = rs.getBoolean("afectaconta");
          } else {
            txtCodMotivo.current.value = "";
            txtDescripcionMotivo.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Motivo de Incorporación no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarResponsable = async () => {
    const campos = "*";
    const id = txtCedula.current.value;
    const nomtab = "incorporacioninmueble";
    const nomid = "cedularesponsable";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtCedula.current.value = data.cedularesponsable;
            txtNombreResponsa.current.value = data.nombreresponsable;
            txtCargo.current.value = data.cargoresponsable;
          } else {
            txtCedula.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El responsable no existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarOrdenPago = async () => {
    const id = txtCodOrden.current.value;
    const endpoint = `${op.conexion}/api/bienes/incorporacioninmueble/seleccionar_ordenpago?&idordenpago=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            console.log(data);

            if (data.reversado === 1) {
              txtCodOrden.current.focus();
              txtCodOrden.current.value = "";

              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "La orden de pago fue reversada",
                icono: "informacion",
              });
            } else {
              if (data.numfactura) {
                txtNumFactura.current.value = data.numfactura;
              } else {
                txtNumFactura.current.value = "";
              }

              txtCodProveedor.current.value = data.idproveedor;
            }
          } else {
            txtNumFactura.current.focus();
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const onClickButton = async (value) => {
    if (value === 1) {
      setOperacion(1);
      setTxtOperacion("[Incluyendo]");
      setVisibleButton(false);
      //setDisabled(false);
      habilitarCampos();
      txtFecha.current.value = new Date().toISOString().slice(0, 10);
      txtFechaAdquisicion.current.value = new Date().toISOString().slice(0, 10);
      setTimeout(() => {
        txtCodActivo.current.focus();
      }, 200);
    } else if (value === 2) {
      setOperacion(2);
      setTxtOperacion("[Editando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtCodActivo.current.focus();
      }, 200);
    } else if (value === 3) {
      setOperacion(3);
      setTxtOperacion("[Eliminando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtCodActivo.current.focus();
      }, 200);
    } else if (value === 4) {
      setOperacion(4);
      setTxtOperacion("[Consultando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtCodActivo.current.focus();
      }, 200);
    } else if (value === 5) {
      setVisibleButton(false);
      await onChangeValidar();
    } else if (value === 6) {
      blanquear();
    }
  };

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">
          Incorporación Bienes Muebles {txtOperacion}
        </h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ height: 450, overflow: "auto" }}>
        <ul
          className="nav d-flex flex-wrap gap-1 align-items-center"
          id="ex-with-icons"
          role="tablist"
        >
          <li className="nav-item " role="presentation">
            <a
              className="nav-link active bg-blue-100 text-light rounded h-100"
              id="nav-datosGenerales-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-datosGenerales"
              type="button"
              role="tab"
              aria-controls="nav-datosGenerales"
              aria-selected="true"
            >
              Datos Generales
            </a>
          </li>

          <li className="nav-item " role="presentation">
            <a
              className="nav-link bg-blue-200 text-light rounded h-100"
              id="nav-caracteristicasInmueble-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-caracteristicasInmueble"
              type="button"
              role="tab"
              aria-controls="nav-caracteristicasInmueble"
              aria-selected="false"
            >
              Características del Mueble
            </a>
          </li>

          <li className="nav-item " role="presentation">
            <a
              className="nav-link bg-blue-300 text-light rounded h-100"
              id="nav-linderos-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-linderos"
              type="button"
              role="tab"
              aria-controls="nav-linderos"
              aria-selected="false"
            >
              Línderos
            </a>
          </li>

          <li className="nav-item " role="presentation">
            <a
              className="nav-link bg-blue-400 text-light rounded h-100"
              id="nav-costos-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-costos"
              type="button"
              role="tab"
              aria-controls="nav-costos"
              aria-selected="false"
            >
              Costos
            </a>
          </li>
        </ul>

        <div className="tab-content mt-2" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-datosGenerales"
            role="tabpanel"
            aria-labelledby="nav-datosGenerales-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-2 m-0 mb-2 p-0">
                <SearchInput
                  ref={txtCodigo}
                  disabled={operacion < 2}
                  onKeyUp={validarCodigo}
                  onBlur={validarCodigo}
                  label="Id Sistema:"
                  name="codigo"
                  onClickButton={() => setMostrarCatalogo(true)}
                  disabledButton={operacion < 2}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <SearchInput
                  ref={txtCodActivo}
                  disabled={operacion < 2}
                  onKeyUp={validarCodigoActivo}
                  onBlur={validarCodigoActivo}
                  label="Id. Tipo Activo:"
                  name="codigo"
                  onClickButton={() => setMostrarCatalogo(true)}
                  disabledButton={operacion < 2}
                />
              </div>
              <div className="col-7 m-0 mb-2 p-0 pl-2">
                <Textarea
                  ref={txtDescripcionActivo}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  label="Descripción:"
                  name="descripcion"
                />
              </div>
              <div className="col-9 m-0 p-0">
                <Input
                  label="Tipo Material:"
                  name="tipomaterial"
                  ref={txtTipoMaterial}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Fecha Incorporación:"
                  name="fecha"
                  type="date"
                  ref={txtFecha}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Orden Pago
                </legend>
                <div className="col-3 m-0 mb-2 p-0">
                  <SearchInput
                    ref={txtCodOrden}
                    disabled={operacion < 2}
                    onKeyUp={validarCodigoOrdenPago}
                    onBlur={validarCodigoOrdenPago}
                    label="Cod. Orden Pago:"
                    name="codordenpago"
                    onClickButton={() => setMostrarCatalogo(true)}
                    disabledButton={operacion < 2}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Factura:"
                    name="numfactura"
                    ref={txtNumFactura}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Fecha Adquisición:"
                    name="fechaadquisicion"
                    type="date"
                    ref={txtFechaAdquisicion}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-3 m-0 p-0">
                    <SearchInput
                      ref={txtCodProveedor}
                      disabled={operacion < 2}
                      onKeyUp={validarCodigoProveedor}
                      onBlur={validarCodigoProveedor}
                      label="Cod. Proveedor:"
                      name="codproveedor"
                      onClickButton={() => setMostrarCatalogo(true)}
                      disabledButton={operacion < 2}
                    />
                  </div>
                  <div className="col-3 m-0 p-0 pl-2">
                    <Input
                      label="C.I. / RIF:"
                      name="cedula"
                      ref={txtRif}
                      disabled={disabled}
                      onChange={onChange}
                      onKeyUp={onNextChange}
                    />
                  </div>
                  <div className="col-6 m-0 p-0 pl-2">
                    <Input
                      label="Nombre / Razón Social:"
                      name="nombre"
                      ref={txtNombre}
                      disabled={disabled}
                      onChange={onChange}
                      onKeyUp={onNextChange}
                    />
                  </div>
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos de la Ubicación
                </legend>
                <div className="col-2 m-0 p-0">
                  <SearchInput
                    ref={txtCodigoUbicacion}
                    disabled={operacion < 2}
                    onKeyUp={validarCodigoUbicacion}
                    onBlur={validarCodigoUbicacion}
                    label="Cod. Ubicación:"
                    name="codubicacion"
                    onClickButton={() => setMostrarCatalogo(true)}
                    disabledButton={operacion < 2}
                  />
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Input
                    label="Descripción:"
                    name="descripcion"
                    ref={txtDescripcionUbicacion}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
                <div className="col-6 m-0 p-0 pl-2">
                  <Input
                    label="Dirección:"
                    name="direccion"
                    ref={txtDireccionUbicacion}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Vida Útil
                </legend>
                <div className="col-3 m-0 p-0">
                  <Input
                    label="Original:"
                    name="original"
                    ref={txtOriginal}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="+"
                    name="mas"
                    ref={txtMas}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="-"
                    name="menos"
                    ref={txtMenos}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="Actual:"
                    name="actual"
                    ref={txtActual}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
              </fieldset>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-caracteristicasInmueble"
            role="tabpanel"
            aria-labelledby="nav-caracteristicasInmueble-tab"
            tabindex="0"
          >
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Mueble
              </legend>
              <div className="col-6 m-0 mb-2 p-0">
                <Input
                  label="Código del Bien:"
                  name="codigobien"
                  ref={txtCodigoBien}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Código Bienes Nacionales:"
                  name="codigobiennacional"
                  ref={txtCodigoBienNacional}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-8 m-0 mb-2 p-0">
                <Input
                  label="Denominación:"
                  name="denominacion"
                  ref={txtDenominacion}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Numero Expediente:"
                  name="numexpediente"
                  ref={txtNumExpediente}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Input
                  label="Detalle:"
                  name="detalle"
                  ref={txtDetalle}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Input
                  label="Avaluo Actual:"
                  name="avaluoactual"
                  ref={txtAvaluoActual}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Avaluo Comisión:"
                  name="avaluocomision"
                  ref={txtAvaluoComision}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Clasificación Funcional:"
                  name="clasificacionfuncional"
                  ref={txtClasificacion}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Input
                  label="Estado Legal Contrucción:"
                  name="estadolegal"
                  ref={txtEdoLegal}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea
                  label="Observación:"
                  name="observacion"
                  ref={txtObservacion}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  style={{ height: 70 }}
                />
              </div>
              <div className="col-4 m-0 p-0 d-flex gap-2">
                <span className="fw-bold">Registro Inmueble:</span>
                <div className="col-auto m-0 p-0">
                  <Radio
                    label="Propio"
                    name="registroInmueble"
                    ref={radioPropio}
                    id="propio"
                    disabled={disabled}
                  />
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio
                    label="Arrendado"
                    name="registroInmueble"
                    ref={radioArrendado}
                    id="arrendado"
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-8 m-0 p-0 pl-2">
                <Input
                  label="Período de Arrendamiento:"
                  name="periodo_arrendamiento"
                  ref={txtPeriodoArrendamiento}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex gap-2  border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Responsable Patrimonial
              </legend>
              <div className="col-3 m-0 p-0">
                <Input
                  label=" Cédula de Identidad:"
                  name="cedula"
                  ref={txtCedula}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <Input
                label="Nombre del Responsable:"
                name="nombre_responsable"
                ref={txtNombreResponsa}
                disabled={disabled}
                onChange={onChange}
                onKeyUp={onNextChange}
              />
            </fieldset>
          </div>
          <div
            className="tab-pane fade"
            id="nav-costos"
            role="tabpanel"
            aria-labelledby="nav-costos-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-3 m-0 mb-2 p-0">
                <Input
                  label="Valor Inicial:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_inicial"
                  ref={txtValorInicial}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Valor Rescate:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_rescate"
                  ref={txtValorRescate}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depressiación Mensual:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="depresacion_mensual"
                  ref={txtDepresiacionMensual}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depresiación Acumulada:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="depresiacion_acumulada"
                  ref={txtDepresiacionAcumulada}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 p-0">
                <Input
                  label="Valor Libros:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_inicial"
                  ref={txtValorLibros}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Adición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_adicion"
                  ref={txtValorAdicion}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Reexpresado:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_reepresado"
                  ref={txtValorReexpresado}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Costo Reposición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="costo_reposicion"
                  ref={txtCostoReposicion}
                  disabled={disabled}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-linderos"
            role="tabpanel"
            aria-labelledby="nav-linderos-tab"
            tabindex="0"
          >
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">Línderos</legend>
              <div className="col-3 m-0 p-0">
                <Textarea
                  label="Norte:"
                  name="norte"
                  disabled={disabled}
                  ref={txtNorte}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  style={{ height: 70 }}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Textarea
                  label="Sur:"
                  name="sur"
                  disabled={disabled}
                  ref={txtSur}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  style={{ height: 70 }}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Textarea
                  label="Este:"
                  name="este"
                  disabled={disabled}
                  ref={txtEste}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  style={{ height: 70 }}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Textarea
                  label="Oeste:"
                  name="oeste"
                  disabled={disabled}
                  ref={txtOeste}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  style={{ height: 70 }}
                />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">Areas</legend>
              <div className="col-3 m-0 p-0">
                <Input
                  label="Area Terreno:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="area_terreno"
                  disabled={disabled}
                  ref={txtAreaTerreno}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Area Contrucción:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="area_construccion"
                  disabled={disabled}
                  ref={txtAreaConstruccion}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Area Cubierta:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="area_cubierta"
                  disabled={disabled}
                  ref={txtAreaCubierta}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Otras Instalaciones:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="otras_instalaciones"
                  disabled={disabled}
                  ref={txtOtrasInsta}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
              <legend className="float-none w-auto m-0">Disposición</legend>
              <div className="col-3 m-0 p-0">
                <SearchInput
                  ref={txtCodMotivo}
                  disabled={operacion < 2}
                  onKeyUp={validarCodigoMotivo}
                  onBlur={validarCodigoMotivo}
                  label="Cod. Motivo:"
                  name="codmotivo"
                  onClickButton={() => setMostrarCatalogo(true)}
                  disabledButton={operacion < 2}
                />
              </div>
              <Input
                label="Descripción:"
                name="descripcion"
                disabled={disabled}
                ref={txtDescripcionMotivo}
                onChange={onChange}
                onKeyUp={onNextChange}
              />
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {visibleButton ? (
          <div className="col-12 d-flex m-auto justify-content-between">
            <SuccessButton onClick={() => onClickButton(1)} icon="fas fa-plus">
              Incluir
            </SuccessButton>
            <InfoButton onClick={() => onClickButton(4)} icon="fas fa-search">
              Consultar
            </InfoButton>
            <WarningButton onClick={() => onClickButton(2)} icon="fas fa-edit">
              Editar
            </WarningButton>
            <DangerButton onClick={() => onClickButton(3)} icon="fas fa-trash">
              Eliminar
            </DangerButton>
          </div>
        ) : (
          <div className="col-12 d-flex m-auto justify-content-end">
            <div className="m-1 p-0">
              <SuccessButton
                disabled={operacion === 4}
                ref={btnAcepta}
                onClick={() => onClickButton(5)}
              >
                Aceptar
              </SuccessButton>
            </div>
            <div className="m-1 p-0">
              <DangerButton ref={btnCancela} onClick={() => onClickButton(6)}>
                Cancelar
              </DangerButton>
            </div>
          </div>
        )}
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
    </Modal>
  );
}
